import { VALIDATION_BLOCK as types } from 'actions/actionTypes';

export const initialState = {
  visible: false,
  violations: []
};

// Holds the state of the single, app-global Optimiser write-block dialog (FR-5.1).
// A blocked write (HTTP 400 + violation list) dispatches SHOW from the axios
// interceptor; acknowledging the dialog dispatches DISMISS.
export const validationBlock = (state = initialState, action) => {
  switch (action.type) {
  case types.SHOW: {
    return { visible: true, violations: action.violations || [] };
  }

  case types.DISMISS: {
    return { ...state, visible: false };
  }

  default:
    return state;
  }
};

export default validationBlock;
